export { default } from './Page404.vue'
